import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'replace',
    standalone: false,
})
export class ReplacePipe implements PipeTransform {
    public transform(value: string, searchValue: string, replaceWith: string): string {
        return value?.replaceAll(searchValue, replaceWith);
    }
}
